import PropTypes from 'prop-types';
import style from '../ModalBoxWrapper.module.less';

function ModalBoxBadge(props) {
	if (!props.text) {
		return;
	}
	return (
		<div
			className={
				style.modalBadge + (props.isCentered ? ' ' + style.modalBadgeCentered : '') + (props.onlyMobile ? ' ' + style.modalBadgeMobile : '')
			}
		>
			{props.text}
		</div>
	);
}

ModalBoxBadge.propTypes = {
	text: PropTypes.string,
	isCentered: PropTypes.bool,
	onlyMobile: PropTypes.bool,
};
ModalBoxBadge.defaultProps = {
	text: '',
	isCentered: false,
	onlyMobile: false,
};

export default ModalBoxBadge;
